module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-overlay', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function() {
        return [_c('div', {
          staticClass: "row"
        }, [_c('b-spinner'), _vm._v("   \n      "), _c('span', {
          attrs: {
            "id": "overlay-text"
          }
        }, [_vm._v(_vm._s(_vm.text))])], 1)]
      },
      proxy: true
    }])
  }, 'b-overlay', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93073bd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextOverlay.vue
// module id = 1338
// module chunks = 16